import React from "react";
import { FiArrowRight, FiClock, FiX } from "react-icons/fi";

/**
 * 상담 팝업 컴포넌트
 * @param {Object} props
 * @param {boolean} props.consultOpen - 팝업 열림 상태
 * @param {Object} props.consult - 폼 상태 { company, name, contact, service, details, privacy }
 * @param {boolean} props.isSending - 전송 중 상태
 * @param {Function} props.closeConsult - 팝업 닫기 핸들러
 * @param {Function} props.updateConsult - 폼 업데이트 핸들러
 * @param {Function} props.submitConsult - 폼 제출 핸들러
 */
export default function ConsultPopup({
  consultOpen,
  consult,
  isSending,
  closeConsult,
  updateConsult,
  submitConsult,
}) {
  if (!consultOpen) return null;

  return (
    <div className="consult-modal" role="dialog" aria-modal="true" aria-labelledby="consult-title">
      <button className="consult-backdrop" type="button" onClick={closeConsult} aria-label="상담창 닫기" />
      <div className="consult-panel">
        <div className="consult-head">
          <div>
            <span>QUICK CONSULTATION</span>
            <h2 id="consult-title">편하게 남겨주세요.</h2>
            <p>내용이 구체적이지 않아도 괜찮습니다. 확인 후 담당자가 연락드리겠습니다.</p>
          </div>
          <button type="button" onClick={closeConsult} aria-label="닫기"><FiX /></button>
        </div>
        <form onSubmit={submitConsult}>
          <div className="consult-row">
            <label>
              <span>회사명 <em>선택</em></span>
              <input name="company" value={consult.company} onChange={updateConsult} placeholder="회사명을 입력해주세요" autoFocus />
            </label>
            <label>
              <span>담당자명 <b>*</b></span>
              <input name="name" value={consult.name} onChange={updateConsult} placeholder="성함을 입력해주세요" required />
            </label>
          </div>
          <label>
            <span>연락처 <b>*</b></span>
            <input name="contact" value={consult.contact} onChange={updateConsult} placeholder="010-0000-0000" inputMode="tel" autoComplete="tel" required />
          </label>
          <label>
            <span>관심 서비스 <b>*</b></span>
            <select name="service" value={consult.service} onChange={updateConsult}>
              <option>맞춤 시스템 구독</option>
              <option>정부지원금 구축</option>
              <option>기존 시스템 전담 운영</option>
              <option>세로 ERP 표준형 신청</option>
              <option>세로 ERP 맞춤형 상담</option>
              <option>맞춤 ERP 도입</option>
              <option>아직 잘 모르겠어요</option>
            </select>
          </label>
          <label>
            <span>어떤 점이 불편하신가요? <em>선택</em></span>
            <textarea name="details" value={consult.details} onChange={updateConsult} placeholder="예: 엑셀로 관리하는 업무가 많아요. 현재 시스템의 유지보수가 어려워요." rows="4" />
          </label>
          <label className="privacy-check">
            <input type="checkbox" name="privacy" checked={consult.privacy} onChange={updateConsult} required />
            <span>상담 연락을 위한 개인정보 수집·이용에 동의합니다. <b>*</b></span>
          </label>
          <details className="privacy-details">
            <summary>개인정보 수집·이용 내용 보기</summary>
            <dl>
              <div><dt>수집 항목</dt><dd>회사명, 담당자명, 연락처, 관심 서비스, 문의 내용</dd></div>
              <div><dt>이용 목적</dt><dd>서비스 도입 상담, 문의 확인 및 회신</dd></div>
              <div><dt>보유 기간</dt><dd>상담 종료일로부터 1년 후 지체 없이 파기</dd></div>
            </dl>
            <p>동의를 거부할 수 있으나, 필수 정보 수집에 동의하지 않으면 상담 신청이 어렵습니다.</p>
          </details>
          <button className="consult-submit" type="submit" disabled={isSending || !consult.privacy}>
            {isSending ? "접수하고 있습니다..." : "상담 신청하기"}<FiArrowRight />
          </button>
          <p className="consult-help"><FiClock /> 평일 기준 빠르게 확인 후 연락드리겠습니다.</p>
        </form>
      </div>
    </div>
  );
}
